<!--
  OFFLINE MODE, SAID OUT LOUD.

  Shown by App.svelte when the shell opened from the cache and the server could
  not be reached, but this browser had been let in before. One line, at the
  top, that does not pretend: what you can do (watch what is on this device)
  and what you cannot (anything that needs Jovii). The retry is a reload,
  because the service worker is network-first and a reload with the network
  back IS the way back online - there is no state to resume.
-->
<script lang="ts">
  import Icon from './Icon.svelte';
</script>

<div class="offline" role="status">
  <Icon name="alert" size={16} />
  <span>You're offline. Your downloads are here; everything else needs a connection.</span>
  <button type="button" onclick={() => location.reload()}>Retry</button>
</div>

<style>
  .offline {
    position: sticky;
    top: 0;
    z-index: var(--z-bar);
    display: flex;
    align-items: center;
    gap: var(--space-2);
    padding: calc(var(--space-2) + var(--safe-t)) max(var(--page-pad), var(--safe-r)) var(--space-2) max(var(--page-pad), var(--safe-l));
    background: var(--surface-2);
    color: var(--text-dim);
    font-size: var(--text-sm);
    border-bottom: 1px solid var(--line);
  }
  .offline span {
    flex: 1;
    min-width: 0;
  }
  .offline button {
    flex: none;
    min-height: 32px;
    padding: 0 var(--space-3);
    border-radius: var(--radius-pill);
    background: var(--surface-3);
    color: var(--text);
    font-weight: var(--weight-semi);
    font-size: var(--text-sm);
  }
</style>
